import PropTypes from "prop-types";
import React from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { Close } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import { Card, Divider, Rating, Switch } from "@mui/material";
import { useEffect } from "react";
import http from "Utils/api";
import SkLoading from "components/SkLoading";
import MDBadge from "components/MDBadge";

import { useDispatch, useSelector } from "react-redux";
import { isgetSingleReview } from "redux/festures/reviewSlice";
import { formattedDateServer } from "Utils/dateFunc";
import { updateReview } from "redux/festures/reviewSlice";
import { handleAlert } from "redux/festures/alertSlice";
import MDButton from "components/MDButton";
import DOMPurify from "dompurify";
import SwiperSlider from "components/SkSlider/Swiper";
import { SwiperSlide } from "swiper/react";

const SingleProduct = ({ single, setViewProductModal }) => {
  const dispatch = useDispatch();
  const admin = localStorage.getItem("admin_id");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  // const [single, setSingle] = useState([]);
  const [isUpdate, setIsUpdate] = useState(null);
  const [readMore, setReadMore] = useState(false);
  const [isId, setIsId] = useState(false);
  const [Loading, setLoading] = useState(false);
  const { onLoading, singleReview } = useSelector((state) => ({ ...state.isReview }));
  // useEffect(() => {
  //   (async () => {
  //     setLoading(true);
  //     await await http
  //       .get(`/getByIdProduct/${viewProductId}`)
  //       .then((data) => {
  //         ;
  //         setLoading(false);
  //         setSingle(data.data.data);
  //       })
  //       .catch((err) => {
  ;
  //         setLoading(false);
  //       });
  //   })();
  // }, [viewProductId]);
  // useEffect(() => {
  //   if (viewProductId) {
  //     dispatch(isgetSingleReview(`/getReviewByProductId/${viewProductId}`));
  //   }
  // }, [viewProductId]);

  ;
  return (
    <>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" sx={{ m: 3 }}>
        <Card
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 , 10px",
          }}
        >
          <MDTypography variant="h6" py={0.9}>
            SingleProduct details
          </MDTypography>
        </Card>

        {/* <MDTypography variant="h6">{viewProductId}</MDTypography> */}
        {/* <MDTypography variant="h6">{setViewProductModal}</MDTypography> */}
      </MDBox>
      {Loading ? (
        <SkLoading />
      ) : (
        single && (
          <MDBox
            sx={({ palette: { dark, white, info } }) => ({
              border: 0.5,
              borderColor: darkMode ? white.main : dark.main,
              borderRadius: 3,
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              p: 2,
              flexDirection: "column",
              gap: 2.5,
            })}
          >
            <MDBox
              display="flex"
              justifyContent="flex-start"
              gap={1}
              px={1}
              alignItems="flex-start"
              width={"100%"}
              height={"100%"}
              flexDirection="column"
            >
              {single?.title && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Product Title :</MDTypography>
                  <MDTypography
                    variant="h6"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": 2,
                      "-webkit-box-orient": "vertical",
                      lineHeight: "30px",
                      maxWidth: "70%",
                    }}
                  >
                    {single?.title || "-"}
                  </MDTypography>
                </MDBox>
              )}
              {single?.subtitle && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Product SubTitle :</MDTypography>
                  <MDTypography
                    variant="h6"
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": 2,
                      "-webkit-box-orient": "vertical",
                      lineHeight: "30px",
                      maxWidth: "70%",
                    }}
                  >
                    {single?.subtitle}
                  </MDTypography>
                </MDBox>
              )}
              {single?.sku && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">SKU :</MDTypography>
                  <MDTypography variant="h6" color="info">
                    {single?.sku}
                  </MDTypography>
                </MDBox>
              )}
              {single?.slug && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Slug :</MDTypography>
                  <MDTypography variant="button" color="text" sx={{ wordBreak: "break-all" }}>
                    {single?.slug}
                  </MDTypography>
                </MDBox>
              )}
              {single?.time && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Delivery / Time :</MDTypography>
                  <MDTypography variant="h6">
                    {single?.time}
                  </MDTypography>
                </MDBox>
              )}
              {single?.returnInDays !== undefined && single?.returnInDays !== null && single?.returnInDays !== "" && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Return Policy :</MDTypography>
                  <MDTypography variant="h6">
                    {`${single?.returnInDays} Days`}
                  </MDTypography>
                </MDBox>
              )}

              {/* Product Image & Product Banners - Side by Side */}
              {((single?.thumnail || single?.thumbnail) || (single?.images && single?.images?.length)) && (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    {" "}
                    <MDBadge
                      badgeContent="Product Image & Banners"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox
                    sx={({ breakpoints }) => ({
                      display: "flex",
                      width: "100%",
                      gap: 2,
                      p: 0.5,
                      [breakpoints.down("md")]: {
                        flexDirection: "column",
                      },
                      [breakpoints.up("md")]: {
                        flexDirection: "row",
                      },
                    })}
                  >
                    {/* Product Image */}
                    {(single?.thumnail || single?.thumbnail) && (
                      <MDBox
                        sx={({ breakpoints }) => ({
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          [breakpoints.down("md")]: {
                            width: "100%",
                          },
                          [breakpoints.up("md")]: {
                            width: single?.images && single?.images?.length ? "50%" : "100%",
                          },
                        })}
                      >
                        <MDTypography variant="button" fontWeight="bold" mb={1}>
                          Product Image
                        </MDTypography>
                        <MDBox
                          sx={{
                            width: "100%",
                            height: "15rem",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={`${process.env.REACT_APP_URI}${single?.thumnail || single?.thumbnail || ""}`}
                            alt={single?.name}
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                            onError={(e) => {
                              e.onerror = null;
                              e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                            }}
                          />
                        </MDBox>
                      </MDBox>
                    )}

                    {/* Product Banners */}
                    {single?.images && single?.images?.length ? (
                      <MDBox
                        sx={({ breakpoints }) => ({
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          [breakpoints.down("md")]: {
                            width: "100%",
                          },
                          [breakpoints.up("md")]: {
                            width: (single?.thumnail || single?.thumbnail) ? "50%" : "100%",
                          },
                        })}
                      >
                        <MDTypography variant="button" fontWeight="bold" mb={1}>
                          Product Banners
                        </MDTypography>
                        <MDBox
                          sx={{
                            width: "100%",
                            height: "15rem",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <SwiperSlider items={1}>
                            {Loading ? (
                              <SkLoading />
                            ) : (
                              single?.images?.map((value, index) => (
                                <SwiperSlide key={index}>
                                  <MDBox
                                    sx={{
                                      height: "15rem",
                                      width: "100%",
                                    }}
                                  >
                                    <img
                                      src={`${process.env.REACT_APP_URI}${value?.url}`}
                                      alt="..."
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                      }}
                                      onError={(e) => {
                                        e.onerror = null;
                                        e.target.src = require("../../../assets/images/bg-sign-in-basic.jpeg");
                                      }}
                                    />
                                  </MDBox>
                                </SwiperSlide>
                              ))
                            )}
                          </SwiperSlider>
                        </MDBox>
                      </MDBox>
                    ) : null}
                  </MDBox>
                </>
              )}
              {single?.additional && single?.additional?.length ? (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    {" "}
                    <MDBadge
                      badgeContent="Additional Banners"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "15rem",
                      p: 0.5,
                    }}
                  >
                    <SwiperSlider items={1}>
                      {Loading ? (
                        <SkLoading />
                      ) : (
                        single?.additional?.map((value, index) => (
                          <SwiperSlide key={index}>
                            <MDBox // sx={{ height: "20rem", width: "100%" }}
                              sx={({ breakpoints }) => ({
                                [breakpoints.up("xs")]: {
                                  height: "10rem",
                                  width: "100%",
                                },
                                [breakpoints.up("sm")]: {
                                  height: "10rem",
                                  width: "100%",
                                },
                                [breakpoints.up("md")]: {
                                  height: "20rem",
                                  width: "100%",
                                },
                                [breakpoints.up("lg")]: {
                                  height: "20rem",
                                  width: "100%",
                                },
                              })}
                            >
                              <img
                                src={`${process.env.REACT_APP_URI}${value?.url}`}
                                alt="..."
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "fill",
                                  borderRadius: "5px",
                                }}
                                onError={(e) => {
                                  e.onerror = null;
                                  e.target.src = require("../../../assets/images/bg-sign-in-basic.jpeg");
                                }}
                              />
                            </MDBox>
                          </SwiperSlide>
                        ))
                      )}
                    </SwiperSlider>
                    {/* <img
                      src={`${process.env.REACT_APP_URI}/${single?.thumnail}`}
                      alt={single?.name}
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                      onError={(e) => {
                        e.onerror = null;
                        e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                      }}
                    /> */}
                  </MDBox>
                </>
              ) : null}
            </MDBox>
            <Divider flexItem></Divider>
            <MDBox
              display="flex"
              justifyContent="flex-start"
              gap={1}
              px={1}
              alignItems="flex-start"
              width={"100%"}
              flexDirection={"column"}
            >
              {single?.categoryId?.name && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Category :</MDTypography>
                  <MDTypography variant="h6">{single?.categoryId?.name}</MDTypography>
                </MDBox>
              )}
              {single?.brandId?.name && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Brand :</MDTypography>
                  <MDTypography variant="h6">{single?.brandId?.name}</MDTypography>
                </MDBox>
              )}
              {single?.cityId?.cityName && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">City :</MDTypography>
                  <MDTypography variant="h6">{single?.cityId?.cityName}</MDTypography>
                </MDBox>
              )}
              {single?.taxId?.taxPercent && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Tax :</MDTypography>
                  <MDTypography variant="h6">{`${single?.taxId?.taxPercent} %`}</MDTypography>
                </MDBox>
              )}
              {single?.include && single?.include?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Include :</MDTypography>
                  <MDTypography variant="h6">{single?.include?.join(",")}</MDTypography>

                  {/* <MDBox
                  // key={i}
                  // width={"100%"}
                  sx={{
                    width: "5rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    gap: 1,
                    flexDirection: "column",
                    height: "auto",
                  }}
                >
                  {single?.include &&
                    single?.include?.length > 0 &&
                    single?.include.map((value, i) => (
                      <MDBadge
                        key={i}
                        badgeContent={value}
                        color="success"
                        variant="gradient"
                        size="md"
                      />
                    ))}
                </MDBox> */}
                </MDBox>
              )}
              {single?.exclude && single?.exclude?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Exclude :</MDTypography>
                  <MDTypography variant="h6">{single?.exclude?.join(",")}</MDTypography>

                  {/* <MDBox
                  // key={i}
                  // width={"100%"}
                  sx={{
                    width: "5rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    gap: 1,
                    flexDirection: "column",
                    height: "auto",
                  }}
                >
                  {single?.include &&
                    single?.include?.length > 0 &&
                    single?.include.map((value, i) => (
                      <MDBadge
                        key={i}
                        badgeContent={value}
                        color="success"
                        variant="gradient"
                        size="md"
                      />
                    ))}
                </MDBox> */}
                </MDBox>
              )}
              {single?.highlights && single?.highlights?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Highlights :</MDTypography>
                  <MDBox
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "flex-end",
                      gap: 1,
                      maxWidth: "70%",
                    }}
                  >
                    {single.highlights.map((val, i) => (
                      <MDBadge
                        key={i}
                        badgeContent={val}
                        color="info"
                        variant="gradient"
                        size="md"
                      />
                    ))}
                  </MDBox>
                </MDBox>
              )}
              {single?.features && single?.features?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Features :</MDTypography>
                  {/* <MDTypography variant="h6">{single?.include?.join(',')}</MDTypography> */}

                  <MDBox
                    // key={i}
                    // width={"100%"}
                    sx={{
                      width: "20rem",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      gap: 1,
                      flexDirection: "column",
                      height: "auto",
                    }}
                  >
                    {single?.features &&
                      single?.features?.length > 0 &&
                      single?.features.map((value, i) => (
                        <MDTypography key={i} variant="h6">
                          {value}
                        </MDTypography>
                      ))}
                  </MDBox>
                </MDBox>
              )}
              {/* ===== VARIANTS SECTION ===== */}
              {single?.variants && single?.variants?.length > 0 ? (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    {" "}
                    <MDBadge
                      badgeContent={`Product Variants (${single.variants.length})`}
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox sx={{ width: "100%", overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "0.875rem",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            borderBottom: `2px solid ${darkMode ? "rgba(255,255,255,0.3)" : "rgba(0,0,0,0.15)"}`,
                          }}
                        >
                          {["#", "Size", "MRP (₹)", "Price (₹)", "Discount (%)", "Stock", "Sold"].map(
                            (header) => (
                              <th
                                key={header}
                                style={{
                                  padding: "10px 12px",
                                  textAlign: "left",
                                  fontWeight: 700,
                                  color: darkMode ? "#fff" : "#344767",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {header}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {single.variants.map((variant, idx) => (
                          <tr
                            key={variant._id || idx}
                            style={{
                              borderBottom: `1px solid ${darkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"}`,
                              backgroundColor:
                                idx % 2 === 0
                                  ? darkMode
                                    ? "rgba(255,255,255,0.03)"
                                    : "rgba(0,0,0,0.02)"
                                  : "transparent",
                            }}
                          >
                            <td
                              style={{
                                padding: "10px 12px",
                                color: darkMode ? "#ccc" : "#344767",
                              }}
                            >
                              {idx + 1}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                fontWeight: 600,
                                color: darkMode ? "#fff" : "#344767",
                              }}
                            >
                              {variant.size || "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                color: darkMode ? "#ccc" : "#344767",
                              }}
                            >
                              {variant.mrp != null
                                ? `₹${Number(variant.mrp).toLocaleString("en-IN")}`
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                color: "#4caf50",
                                fontWeight: 600,
                              }}
                            >
                              {variant.price != null
                                ? `₹${Number(variant.price).toLocaleString("en-IN")}`
                                : "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                color: variant.discount > 0 ? "#ff9800" : darkMode ? "#ccc" : "#344767",
                                fontWeight: variant.discount > 0 ? 600 : 400,
                              }}
                            >
                              {variant.discount != null ? `${variant.discount}%` : "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                color:
                                  variant.stock === 0
                                    ? "#f44336"
                                    : variant.stock <= 5
                                    ? "#ff9800"
                                    : darkMode
                                    ? "#ccc"
                                    : "#344767",
                                fontWeight: variant.stock <= 5 ? 600 : 400,
                              }}
                            >
                              {variant.stock != null ? variant.stock : "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                color: darkMode ? "#ccc" : "#344767",
                              }}
                            >
                              {variant.sold != null ? variant.sold : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </MDBox>

                  {/* Total Stock & Sold Summary */}
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    gap={2}
                    alignItems="center"
                    width={"100%"}
                    mt={1}
                  >
                    <MDTypography variant="h6">Total Stock :</MDTypography>
                    <MDTypography variant="h6">
                      {single.variants.reduce((sum, v) => sum + (v.stock || 0), 0)}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    gap={2}
                    alignItems="center"
                    width={"100%"}
                  >
                    <MDTypography variant="h6">Total Sold :</MDTypography>
                    <MDTypography variant="h6">
                      {single.variants.reduce((sum, v) => sum + (v.sold || 0), 0)}
                    </MDTypography>
                  </MDBox>
                </>
              ) : (
                /* Fallback: show flat Stock, Sold, Price, MRP when no variants */
                <>
                  {single?.stock?.toString() && (
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      gap={2}
                      alignItems="center"
                      width={"100%"}
                    >
                      <MDTypography variant="h6">Stock :</MDTypography>
                      <MDTypography variant="h6">{single?.stock}</MDTypography>
                    </MDBox>
                  )}
                  {single?.sold?.toString() && (
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      gap={2}
                      alignItems="center"
                      width={"100%"}
                    >
                      <MDTypography variant="h6">Sold :</MDTypography>
                      <MDTypography variant="h6">{single?.sold}</MDTypography>
                    </MDBox>
                  )}
                  {single?.price && (
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      gap={2}
                      alignItems="center"
                      width={"100%"}
                    >
                      <MDTypography variant="h6">Price :</MDTypography>
                      <MDTypography variant="h6">
                        {single?.price.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </MDTypography>
                    </MDBox>
                  )}
                  {single?.mrp && (
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      gap={2}
                      alignItems="center"
                      width={"100%"}
                    >
                      <MDTypography variant="h6">MRP :</MDTypography>
                      <MDTypography variant="h6">
                        {single?.mrp.toLocaleString("en-US", {
                          style: "currency",
                          currency: "INR",
                        })}
                      </MDTypography>
                    </MDBox>
                  )}
                </>
              )}

              {/* Paint Color Codes & Shade Palette Section */}
              {single?.colors && single?.colors?.length > 0 && (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    <MDBadge
                      badgeContent={`Paint Shade Palette (${single.colors.length} Shades)`}
                      color="info"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox
                    display="flex"
                    flexWrap="wrap"
                    gap={1.5}
                    width={"100%"}
                    py={1.5}
                  >
                    {single.colors.map((color, cIdx) => (
                      <MDBox
                        key={cIdx}
                        sx={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 1.5,
                          p: 1,
                          pr: 2,
                          borderRadius: "10px",
                          border: `1px solid ${darkMode ? "rgba(255,255,255,0.15)" : "#e0e0e0"}`,
                          backgroundColor: darkMode ? "rgba(255,255,255,0.03)" : "#f9f9f9",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            width: "28px",
                            height: "28px",
                            borderRadius: "50%",
                            backgroundColor: color.hex || "#ffffff",
                            border: "2px solid #ddd",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
                          }}
                        />
                        <MDBox display="flex" flexDirection="column">
                          <MDTypography variant="button" fontWeight="bold" lineHeight={1}>
                            {color.name || "Shade"}
                          </MDTypography>
                          <MDTypography variant="caption" color="text" fontSize={11}>
                            Code: {color.code || "-"} {color.family ? `(${color.family})` : ""}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    ))}
                  </MDBox>

                  {single?.allowCustomColorCode && (
                    <MDBox width="100%">
                      <MDTypography variant="caption" color="success" fontWeight="medium">
                        ✓ Custom shade code input enabled for customers
                      </MDTypography>
                    </MDBox>
                  )}
                </>
              )}
              {single?.warranty && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Warranty :</MDTypography>
                  <MDTypography variant="h6">
                    {`${single?.warranty} Days`}{" "}
                  </MDTypography>
                </MDBox>
              )}
              {single?.reviewRating !== 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Review :</MDTypography>
                  <MDTypography variant="h6">
                    <Rating
                      sx={{ color: "info" }}
                      name="half-rating-read"
                      defaultValue={single?.reviewRating}
                      precision={0.5}
                      readOnly
                    />
                  </MDTypography>
                </MDBox>
              )}

              {single?.description && (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    {" "}
                    <MDBadge
                      badgeContent="Description"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    gap={2}
                    alignItems="flex-start"
                    width={"100%"}
                  >
                    <MDBox
                      sx={({ palette: { dark, white } }) => ({
                        width: "100%",
                        lineHeight: "1.8",
                        fontSize: "0.875rem",
                        fontWeight: 400,
                        color: darkMode ? white.main : dark.main,
                        "& h1, & h2, & h3, & h4, & h5, & h6": {
                          marginTop: "0.5rem",
                          marginBottom: "0.5rem",
                          fontWeight: 600,
                        },
                        "& p": {
                          marginBottom: "0.5rem",
                        },
                        "& ul, & ol": {
                          paddingLeft: "1.5rem",
                          marginBottom: "0.5rem",
                        },
                        "& li": {
                          marginBottom: "0.25rem",
                        },
                        "& a": {
                          color: "#1a73e8",
                          textDecoration: "underline",
                        },
                        "& img": {
                          maxWidth: "100%",
                          height: "auto",
                          borderRadius: "4px",
                        },
                        "& table": {
                          width: "100%",
                          borderCollapse: "collapse",
                          marginBottom: "0.5rem",
                        },
                        "& th, & td": {
                          border: "1px solid",
                          borderColor: darkMode ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)",
                          padding: "0.5rem",
                        },
                      })}
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(single?.description) }}
                    />
                  </MDBox>
                </>
              )}

              {single?.specifications && (
                (Array.isArray(single.specifications) && single.specifications.length > 0) ||
                (typeof single.specifications === "string" && single.specifications.trim() !== "")
              ) && (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    <MDBadge
                      badgeContent="Specifications"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox sx={{ width: "100%", overflowX: "auto", mt: 1 }}>
                    {Array.isArray(single.specifications) ? (
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "0.875rem",
                        }}
                      >
                        <tbody>
                          {single.specifications.map((spec, i) => {
                            const key = typeof spec === "object" ? spec?.key : spec?.split?.(/:(.+)/)?.[0];
                            const value = typeof spec === "object" ? spec?.value : spec?.split?.(/:(.+)/)?.[1];
                            if (!key && !value) return null;
                            return (
                              <tr
                                key={i}
                                style={{
                                  borderBottom: `1px solid ${darkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"}`,
                                  backgroundColor: i % 2 === 0 ? (darkMode ? "rgba(255,255,255,0.03)" : "rgba(0,0,0,0.02)") : "transparent",
                                }}
                              >
                                <td
                                  style={{
                                    padding: "10px 14px",
                                    fontWeight: 600,
                                    width: "35%",
                                    color: darkMode ? "#fff" : "#344767",
                                  }}
                                >
                                  {key || "-"}
                                </td>
                                <td
                                  style={{
                                    padding: "10px 14px",
                                    color: darkMode ? "#ccc" : "#344767",
                                  }}
                                >
                                  {value || "-"}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <MDTypography variant="body2" sx={{ whiteSpace: "pre-wrap", p: 1 }}>
                        {single.specifications}
                      </MDTypography>
                    )}
                  </MDBox>
                </>
              )}

              <MDBox
                sx={({ palette: { dark, white, info } }) => ({
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  borderTop: 1,
                  borderTopColor: darkMode ? white.main : info.main,
                  mt: 3,
                })}
              >
                {" "}
                <MDBadge
                  badgeContent="Meta Data"
                  color="success"
                  variant="gradient"
                  size="lg"
                  sx={{ zIndex: 10, mt: -1.5 }}
                />
              </MDBox>
              {/* Meta Title */}
              <MDBox
                sx={({ breakpoints }) => ({
                  display: "flex",
                  width: "100%",
                  gap: 1,
                  [breakpoints.down("sm")]: {
                    flexDirection: "column",
                  },
                  [breakpoints.up("sm")]: {
                    flexDirection: "row",
                    alignItems: "flex-start",
                  },
                })}
              >
                <MDTypography
                  variant="h6"
                  sx={{ minWidth: "120px", flexShrink: 0, whiteSpace: "nowrap" }}
                >
                  Title :
                </MDTypography>
                <MDTypography
                  variant="h6"
                  sx={{
                    fontWeight: 400,
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    flex: 1,
                  }}
                >
                  {single?.meta?.title || "-"}
                </MDTypography>
              </MDBox>

              {/* Meta Description */}
              <MDBox
                sx={({ breakpoints }) => ({
                  display: "flex",
                  width: "100%",
                  gap: 1,
                  [breakpoints.down("sm")]: {
                    flexDirection: "column",
                  },
                  [breakpoints.up("sm")]: {
                    flexDirection: "row",
                    alignItems: "flex-start",
                  },
                })}
              >
                <MDTypography
                  variant="h6"
                  sx={{ minWidth: "120px", flexShrink: 0, whiteSpace: "nowrap" }}
                >
                  Description :
                </MDTypography>
                <MDTypography
                  variant="h6"
                  sx={{
                    fontWeight: 400,
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                    flex: 1,
                  }}
                >
                  {single?.meta?.description || "-"}
                </MDTypography>
              </MDBox>

              {/* Meta Keywords */}
              {single?.meta?.keywords && single?.meta?.keywords?.length > 0 && (
                <MDBox
                  sx={({ breakpoints }) => ({
                    display: "flex",
                    width: "100%",
                    gap: 1,
                    [breakpoints.down("sm")]: {
                      flexDirection: "column",
                    },
                    [breakpoints.up("sm")]: {
                      flexDirection: "row",
                      alignItems: "flex-start",
                    },
                  })}
                >
                  <MDTypography
                    variant="h6"
                    sx={{ minWidth: "120px", flexShrink: 0, whiteSpace: "nowrap", pt: 0.5 }}
                  >
                    Keywords :
                  </MDTypography>
                  <MDBox
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 1,
                      flex: 1,
                    }}
                  >
                    {single.meta.keywords.map((keyword, i) => (
                      <MDBadge
                        key={i}
                        badgeContent={keyword}
                        color="info"
                        variant="gradient"
                        size="sm"
                        container
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "relative",
                            transform: "none",
                            fontSize: "0.75rem",
                            padding: "0.35rem 0.75rem",
                            whiteSpace: "nowrap",
                          },
                        }}
                      />
                    ))}
                  </MDBox>
                </MDBox>
              )}
              {/* {single?.ofPrice && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Final Price :</MDTypography>
                  <MDTypography variant="h6">
                    {single?.ofPrice.toLocaleString("en-US", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </MDTypography>
                </MDBox>
              )}
              {single?.minimumQuantity && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Minimum Quantity :</MDTypography>
                  <MDTypography variant="h6">{single?.minimumQuantity}</MDTypography>
                </MDBox>
              )} */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Refundable :</MDTypography>

                {single?.refundable ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox>

              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Variant :</MDTypography>{" "}
                {single?.variant ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* {single?.quantity && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Qty :</MDTypography>
                  <MDTypography variant="h6">{single?.quantity}</MDTypography>
                </MDBox>
              )} */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Featured :</MDTypography>

                {single?.featured ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Bestselling :</MDTypography>
          
                {single?.bestselling ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Trending :</MDTypography>
              
                {single?.trending ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* {single?.gst && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">GST :</MDTypography>
                  <MDTypography variant="h6">{single?.gst}</MDTypography>
                </MDBox>
              )} */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">COD :</MDTypography>
               
                {single?.cod ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* {single?.showStock && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Show Stock :</MDTypography> */}
              {/* <MDTypography variant="h6">{single?.showStock ? "Yes" : "No"}</MDTypography>
              {single?.showStock ? (
                <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
              ) : (
                <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
              )}
            </MDBox>
              )}

            {single?.hideStock && (
              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Hide Stock :</MDTypography>
                {/* <MDTypography variant="h6">{single?.hideStock ? "Yes" : "No"}</MDTypography> */}
              {/* {single?.hideStock ? (
                    <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                  ) : (
                    <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                  )}
                </MDBox> */}
              {/* )} */}
              {/* {single?.visibility && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Visibility :</MDTypography> */}
              {/* <MDTypography variant="h6">{single?.visibility ? "Yes" : "No"}</MDTypography> */}
              {/* {single?.visibility ? (
                    <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                  ) : (
                    <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                  )}
                </MDBox> */}
              {/* )}  */}
            </MDBox>
          </MDBox>
        )
      )}
      {/* {singleReview && singleReview?.length > 0 && (
        <MDBox
          sx={({ palette: { dark, white, info } }) => ({
            display: "flex",
            border: 0.5,
            borderColor: darkMode ? white.main : dark.main,
            borderRadius: 3,
            flexWrap: "Wrap",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            width: "100%",
            gap: 5.5,
            my: 4,
            py: 5,
            px: 1,
          })}
        >
          {onLoading ? (
            <SkLoading />
          ) : (
            singleReview &&
            singleReview?.length > 0 &&
            singleReview.map((value) => (
              <Card
                key={value?._id}
                sx={{
                  maxWidth: 350,
                }}
              >
                <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
                  <MDBox display="flex" justifyContent="center" gap={2} width={"100%"}>
                    <MDBox
                      variant="gradient"
                      bgColor={"success"}
                      color={"success" === "light" ? "dark" : "white"}
                      coloredShadow={"success"}
                      borderRadius="xl"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="6rem"
                      height="6rem"
                      mt={-3}
                    >
                      <img
                        src={`${process.env.REACT_APP_URI}/${value?.userId?.image}`}
                        onError={(e) => {
                          e.onerror = null;
                          e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                        }}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </MDBox>
                    <MDBox>
                      <MDTypography variant="h6">{value?.userId?.firstName}</MDTypography>
                      <MDTypography variant="button" fontSize={11}>
                        {value?.userId?.email}
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="300" fontSize={11}>
                        {value?.updatedAt &&
                          `Last Update :${formattedDateServer(new Date(value?.updatedAt))}`}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDTypography variant="h4">{value?.name}</MDTypography>
                </MDBox >

                <Divider />
                <MDBox pb={2} px={2}>
                  {value?.comment?.length > 50 ? (
                    <>
                      {readMore && value?._id === isId ? (
                        <MDTypography variant="h6">
                          {value?.comment}{" "}
                          <MDButton
                            variant="text"
                            color="info"
                            size="sm"
                            onClick={() => {
                              setReadMore(false);
                              setIsId(value?._id);
                            }}
                          >
                            Read less
                          </MDButton>{" "}
                        </MDTypography>
                      ) : (
                        <MDTypography variant="h6">
                          {value?.comment?.slice(0, 20)} ...{" "}
                          <MDButton
                            variant="text"
                            color="info"
                            size="sm"
                            onClick={() => {
                              setReadMore(true);
                              setIsId(value?._id);
                            }}
                          >
                            Read More
                          </MDButton>
                        </MDTypography>
                      )}
                    </>
                  ) : (
                    <MDTypography variant="h6">{value?.comment}</MDTypography>
                  )}
                  {value?.rating && (
                    <>
                      <MDBadge
                        badgeContent={"  Rating : "}
                        color="success"
                        variant="gradient"
                        size="lg"
                      />
                      <Rating
                        name="half-rating-read"
                        defaultValue={value?.rating}
                        precision={0.5}
                        readOnly
                      />
                    </>
                  )}
                </MDBox>
                <Divider />
                <MDBox
                  pb={2}
                  px={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <MDTypography variant="h6">disable</MDTypography>
                  {value?.disable ? (
                    <MDBadge badgeContent="Yes" color="success" variant="gradient" size="lg" />
                  ) : (
                    <MDBadge badgeContent="No" color="error" variant="gradient" size="lg" />
                  )}
                  <Switch
                    value={value?.disable}
                    checked={value?.disable}
                    color={"info"}
                    onChange={(e) => {
                      dispatch(
                        updateReview({
                          url: `${process.env.REACT_APP_API}/disableReview/${value?._id}/${admin}`,
                        })
                      ).then((data) => {
                        dispatch(
                          handleAlert({
                            isOpen: true,
                            type: `${data?.payload?.success ? "success" : "error"}`,
                            msg: data?.payload?.message,
                          })
                        );
                        if (data?.payload?.success) {
                          dispatch(isgetSingleReview(`/getReviewByProductId/${viewProductId}`));
                        }
                      });
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </MDBox>
              </Card >
            ))
          )}
        </MDBox >
      )}  */}
    </>
  );
};

export default SingleProduct;

SingleProduct.propTypes = {
  //   children: PropTypes.node,
  single: PropTypes.any,
  setViewProductModal: PropTypes.any,
};
